"use strict";

/**
 * @file
 * Standalone LP enhancements.
 */
(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.careyStandaloneLpStickyForm = {
    attach: function attach(context) {
      $(once('careyStandaloneLpStickyForm', '.page-node-type-standalone-landing-page #main-form', context)).each(function () {
        var $form = $(this);
        var offset = null;
        var timeout = null;

        function checkSlateLoaded() {
          window.clearTimeout(timeout); // Look for loaded form.

          if ($('.paragraph--type--slate-form form input[name="id"]', $form).length) {
            // Give it a little extra time just in case there is reflow.
            window.setTimeout(checkSticky, 100);
          } else {
            timeout = window.setTimeout(checkSlateLoaded, 100);
          }
        }

        function checkPardotLoaded() {
          window.clearTimeout(timeout); // Look for loaded form.

          if ($('.paragraph--type--pardot-form iframe[src][src!=""]', $form).length) {
            checkSticky();
          } else {
            timeout = window.setTimeout(checkPardotLoaded, 100);
          }
        }

        function checkSticky() {
          var $windowWidth = $(window).width();

          if ($windowWidth > 767) {
            var $windowHeight = $(window).height();
            var $formHeight = $form.outerHeight();
            var $preFooter = $('.pre-footer');

            if ($formHeight < $windowHeight) {
              offset = $form.position();
              $form.sticky({
                topSpacing: offset.top,
                bottomSpacing: $(document).outerHeight() - $preFooter.offset().top
              });
            } else {
              $form.unstick();
              $('.carey-back-to-top').sticky({
                topSpacing: 0,
                bottomSpacing: $(document).outerHeight() - $preFooter.offset().top,
                zIndex: 100
              }).on('sticky-start', function () {
                $(this).show();
              }).on('sticky-end', function () {
                $(this).hide();
              });
            }
          }
        } // Test if form height changed.

        setTimeout(function () {
          $form.find('select').change(function () {
            setTimeout(function () {
              checkSticky();
            }, 100);
          });
        }, 500);

        if ($('.paragraph--type--slate-form', $form).length) {
          checkSlateLoaded();
        } else if ($('.paragraph--type--pardot-form', $form).length) {
          checkPardotLoaded();
        }
      });
    }
  };
})(jQuery, Drupal, once);
